module.exports = "<svg id=\"16a11400-189e-4663-b884-7a83f62097b6\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 69\"><title>ArrowLft</title><g id=\"cb29e0e2-6e30-4ea2-aefd-ea26a1733052\" data-name=\"Mockup-V2.0\"><g id=\"5137b01f-b316-4cd6-9df4-8d419b1cd250\" data-name=\"V3\"><polygon id=\"564b4833-99cb-4269-8103-a07a75da29a4\" data-name=\"Fill-1\" points=\"43 0 43 15.13 18 34.5 43 53.72 43 69 0 34.5 43 0\"></polygon></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ArrowLft.svg
// module id = fnuc
// module chunks = 2